import type { ScreenModule } from "../../../app/screen-module";
import { SolutionDetailPage } from "../pages";

export default {
	id: "public.solution-detail",
	path: "/solutions/:verticalKey",
	area: "public",
	label: "業種別LP",
	roles: [],
	backing: "MOCK_ONLY",
	enabled: true,
	component: SolutionDetailPage,
} satisfies ScreenModule;
